export default "__VITE_ASSET__CnReY84W__"